import SkipNextIcon from "@mui/icons-material/SkipNext";
import { Button, IconButton, Tooltip } from "@mui/material";
import React from "react";

interface ParkNextButtonProps {
  onClick: () => void;
  disabled: boolean;
  disabledMessage?: string;
  compact?: boolean;
  inGroup?: boolean;
  fullWidth?: boolean;
}

export const ParkNextButton: React.FC<ParkNextButtonProps> = ({
  onClick,
  disabled,
  disabledMessage = "No unplaced aircraft available.",
  compact = false,
  inGroup = false,
  fullWidth = false,
}) => {
  const button = compact ? (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size="small"
    >
      <SkipNextIcon />
    </IconButton>
  ) : (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      startIcon={<SkipNextIcon />}
      fullWidth={fullWidth}
      disabled={disabled}
      size="small"
    >
      Park Next
    </Button>
  );

  const tooltipTitle = compact ? "Park Next" : disabled ? disabledMessage : "";

  if (disabled || compact) {
    return (
      <Tooltip title={tooltipTitle || disabledMessage}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
